import * as React from "react";
import { forwardRef } from "react";
const SvgTachoCardStatusCrossIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0ZM18.7 17.29L17.29 18.7L12 13.41L6.71 18.7L5.3 17.29L10.59 12L5.3 6.71L6.71 5.3L12 10.59L17.29 5.3L18.7 6.71L13.41 12L18.7 17.29Z", fill: "#EB3B5A" }));
const ForwardRef = forwardRef(SvgTachoCardStatusCrossIcon);
export default ForwardRef;
